import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useFieldArray } from "react-hook-form";
import classes from "./formFieldArray.module.css";

export const FormFieldArray = ({
  name,
  label,
  register,
  disabled,
  validation,
  control,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });


  const handleRemove = (index) => {
    remove(index);
  };

  return (
    <motion.div
      layout
      className={classes.box}
      transition={{
        layout: {
          duration: 0.4,
          ease: [0.25, 0.8, 0.25, 1],
        },
      }}
    >
      <label className={classes.box__title}>{label}</label>

      <AnimatePresence>
        {fields.map((field, index) => (
          <motion.div
            key={field.id}
            layout
            className={classes.box__content}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.3 }}
          >
            <textarea
              rows={3}
              className={classes.box__content__input}
              placeholder="Enter Detail..."
              disabled={disabled}
              {...register(`${name}.${index}`, validation)}
            />
            <button
              type="button"
              onClick={() => handleRemove(index)}
              className={classes.box__content__input__delete}
            />
          </motion.div>
        ))}
      </AnimatePresence>

      <button
        type="button"
        onClick={() => append("")}
        className={classes.box__add}
      >
        + Add
      </button>
    </motion.div>
  );
};
